"use client";

import Link from "next/link";
import { ArrowRight, Shield, Award, Users, Globe, Activity } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { cta as data } from "@/lib/data/platform-features";

const trustIcons = [Shield, Award, Users, Globe, Activity] as const;
const accents = ["var(--color-crimson)", "var(--color-amber)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)"] as const;

export function Cta() {
  return (
    <Section id="contact" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[600px] w-[600px] rounded-full bg-[var(--color-crimson)] opacity-25 blur-[160px] animate-pulse-glow" />
        <div className="absolute top-1/3 right-1/4 h-72 w-72 rounded-full bg-[var(--color-purple)] opacity-20 blur-[120px]" style={{ animationDelay: "2s" }} />
      </div>

      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-10 flex flex-wrap items-center gap-3">
            <Link href={data.ctaPrimary.href} className="btn-primary-gradient h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base shadow-2xl shadow-[var(--color-crimson)/40]">
              {data.ctaPrimary.label} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link href={data.ctaSecondary.href} className="btn-glass h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base">
              {data.ctaSecondary.label}
            </Link>
          </div>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-12 glass rounded-2xl p-5">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
              {data.trustBar.map((item, i) => {
                const Icon = trustIcons[i % trustIcons.length]!;
                const accent = accents[i % accents.length]!;
                return (
                  <div key={item} className="flex items-center gap-2">
                    <Icon className="h-4 w-4 shrink-0" style={{ color: accent }} />
                    <span className="text-xs font-semibold leading-tight">{item}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
